// extracted by mini-css-extract-plugin
export default {"tab-button":"TabButton_tab-button__Bqam7","inactive":"TabButton_inactive__tiRYg","active":"TabButton_active__sS93b"};